import React, { useState, useEffect } from "react";
import { t } from 'i18next';

import { useUderlyStore } from "@uderly/react-uderly-ui/zustand";
import Module from '../components/Module';
import { GridColDef } from "@mui/x-data-grid";

import { IqStore } from "../../models/IqStore";
import CellMediaThumb from "../components/Module/CellMediaThumb";
import { StoreBreadcrumbs } from "../components/Module/StoreBreadcrumbs";

interface GridRow {
	id: number;
	media?: Array<any>;
	gamename: string;
}

interface GridCellParams {
	row: GridRow;
}

const Followers = () => {
	const zustandStore = useUderlyStore(s => s.store);
	const [store, setStore] = useState<IqStore | null>(zustandStore as IqStore);

	const moduleData = {
		title: <StoreBreadcrumbs store={store} path="/followers" />,
		name: t('followers'),
		path: "/followers",
		apiBasePath: '/followers'
	};
	// const [isPremium, setIsPremium] = useState<boolean | null>(null);

	const apiPath = "/users";

	useEffect(() => {
		if (zustandStore) {
			// setStore(stores[0]);
			// setIsPremium(
			// 	stores[0].premium_id > 0 &&
			// 	(!stores[0].premium_ends_in || stores[0].premium_ends_in > 0)
			// );
		}
	}, []);

	const columns: GridColDef[] = [
		{
			field: 'name',
			headerName: t('name') as string,
			minWidth: 100,
			flex: 1,
			sortable: false,
			hideable: false,
			renderCell: (params: GridCellParams) => {
				const { row } = params;

				return (
					<div className="td-v-center">
						<CellMediaThumb o={row} path={apiPath as string} />

						{row.gamename}
					</div>
				);
			}
		},
	];

	if (!store) {
		return null;
	}

	return (
		<>
			<Module
				columns={columns}
				initialFilters={{ store_id: store.id }}
				disableInsert
				data={moduleData} />
			{/* 
				viewClassName="event-mask"
				noItemsMessage={
					<>
						<p>{t('no-followers')}</p>
						<p>{t('share-your-space')}</p>
					</>
				} */}
		</>
	);
};

export default Followers;